module.exports = __webpack_public_path__ + "static/tat-18-c067ec0981dab2bf062c75671e3dbcdf.jpg";